import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { setAriaLiveRegionContents } from "../actions/ui";
import { selectAriaLiveRegionContents } from "../reducers";

export const AriaLiveRegion = ({ ariaLiveRegionContents, setAriaLiveRegionContents }) => {
    const timeout = useRef(null);

    useEffect(() => {
        if (ariaLiveRegionContents) {
            timeout.current = setTimeout(() => {
                timeout.current = null;
                setAriaLiveRegionContents("");
            }, 5000);
        }

        return () => {
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, [ariaLiveRegionContents]);

    // if (!ariaLiveRegionContents) return null;

    return (
        <div
            className="visually-hidden"
            id="crown-lands-live-region"
            role="region"
            aria-live="polite"
        >
            {ariaLiveRegionContents}
        </div>
    );
};

AriaLiveRegion.propTypes = {
    ariaLiveRegionContents: PropTypes.string,
    setAriaLiveRegionContents: PropTypes.func,
};

const mapStateToProps = s => ({
    ariaLiveRegionContents: selectAriaLiveRegionContents(s),
});
const mapDispatchToProps = {
    setAriaLiveRegionContents,
};
export default connect(mapStateToProps, mapDispatchToProps)(AriaLiveRegion);



// WEBPACK FOOTER //
// ./src/components/aria-live-region.js